import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { take } from 'rxjs';
import { IntegerValidator } from 'src/core/validators/shared/integer.validator';

@Component({
  selector: 'ca-automatic-summarization-settings',
  templateUrl: './automatic-summarization-settings.component.html',
  styleUrls: ['./automatic-summarization-settings.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  standalone: false,
})
export class AutomaticSummarizationSettingsComponent implements OnInit, OnChanges {
  @Input() maxDailyConversationLimit: number = Number.MAX_SAFE_INTEGER;

  get form(): FormGroup {
    return this.formGroupDirective.form;
  }

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {
    this.form.valueChanges.pipe(take(1)).subscribe(value => {
      this.setValidators(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['maxDailyConversationLimit'] && !changes['maxDailyConversationLimit'].firstChange) {
      this.setValidators(this.form.value);
    }
  }

  setValidators(formValues): void {
    const filter = formValues.automaticSummarizationFilterConversations.toLowerCase() === 'true';

    if (!formValues.automaticSummarizationEnabled) {
      this.form.get('automaticSummarizationCategories').clearValidators();
      this.form.get('automaticSummarizationDailyConversationLimit').clearValidators();
    } else if (formValues.automaticSummarizationEnabled && filter) {
      this.form.get('automaticSummarizationCategories').addValidators([Validators.required]);
      this.form
        .get('automaticSummarizationDailyConversationLimit')
        .addValidators([IntegerValidator.minMax(0, this.maxDailyConversationLimit)]);
    } else if (formValues.automaticSummarizationEnabled) {
      this.form
        .get('automaticSummarizationDailyConversationLimit')
        .addValidators([IntegerValidator.minMax(0, this.maxDailyConversationLimit)]);
      this.form.get('automaticSummarizationCategories').clearValidators();
    }

    this.form.updateValueAndValidity();

    this.form.valueChanges.pipe(take(1)).subscribe(value => {
      this.setValidators(value);
    });
  }
}
